import { Loader } from '@googlemaps/js-api-loader';

const maps = document.querySelectorAll('.gmap');

if (maps.length) {
  document.addEventListener('DOMContentLoaded', () => {
    const loader = new Loader({
      apiKey: window.gmapi,
      version: 'weekly',
      libraries: ['geometry']
    });
    loader.load().then(() => {
      maps.forEach((mapWrap) => {
        const loc = {
          lat: parseFloat(mapWrap.getAttribute('data-lat')),
          lng: parseFloat(mapWrap.getAttribute('data-lng'))
        };
        let map = new google.maps.Map(mapWrap, {
          center: loc,
          zoom: parseInt(mapWrap.getAttribute('data-zoom')) || 15
        });

        const marker = new google.maps.Marker({
          position: loc,
          map: map
        });
      });
    });

  })
}